import React from "react";
import PointTarget from 'react-point';
import NnKeyConstants from '../music/NnKeyConstants';


class NnPianoOctaveSelector extends React.Component {
  constructor(props) {
    super(props);

    this.setOctave = this.setOctave.bind(this);
    this.getOctaveLabel = this.getOctaveLabel.bind(this);
  }

  render() {
    return (
      <div className="piano-octave-selector">
        {NnKeyConstants.octaves.map((octave) => (
          <PointTarget onPoint={()=>this.setOctave(octave)} key={octave}>
            <button className={this.getClassName(octave)}>{this.getOctaveLabel(octave, this.props.letters)}</button>
          </PointTarget>
        ))}
      </div>
    );
  }

  getClassName(octave) {
    return `piano-octave-button octave${octave}` + ((octave === this.props.octave) ? " selected" : " not-selected")
  }

  setOctave(octave) {
    // TODO: uncomment following line to enble octave select buttons
    // this.props.onClick(octave);
  }

  getOctaveLabel(octave, letters) {
    const labels = letters ? [`'''C`, `"C`, `'C`, `C`, `C'`, `C"`, `C'''`]
    : [`'''1`, `"1`, `'1`, `1`, `1'`, `1"`, `1'''`];
    return labels[octave - 1];
  }
}
export default NnPianoOctaveSelector;
